import React, { useState, useEffect } from 'react';
import '../Customers.css';
import './Report.css';
import { Switch, Route, useParams, useRouteMatch } from 'react-router-dom';
import { getDatabase, onValue, get, ref } from 'firebase/database';
import Navigation from '../../../navigation/Navigation';
import PageHeading from '../../../shared/pageHeading/PageHeading';
const GetReport = () => {
	let { uid } = useParams();
	const [transactions, setTransactions] = useState([]);
	const [user, setUser] = useState([]);
	useEffect(() => {
		const db = getDatabase();
		onValue(ref(db, 'transactions/' + uid), snapshot => {
			if (snapshot.exists()) {
				setTransactions(
					Object.entries(snapshot.val()).map(([key, value]) => {
						return { key: key, value: value };
					})
				);
			}
		});
		get(ref(db, `users/${uid}`))
			.then(snapshot => {
				if (snapshot.exists()) {
					setUser(snapshot.val());
				}
			})
			.catch(error => {
				console.error('@Report-->', error);
			});
	}, [uid]);
	const GetDateAndTime = time => {
		let timestamp = new Date(time);
		let date = timestamp.getDate();
		let month = timestamp.getMonth() + 1;
		let year = timestamp.getFullYear();
		let hour = (timestamp.getHours() < 10 ? '0' : '') + timestamp.getHours();
		let minutes = (timestamp.getMinutes() < 10 ? '0' : '') + timestamp.getMinutes();
		let seconds = (timestamp.getSeconds() < 10 ? '0' : '') + timestamp.getSeconds();
		return {
			time: hour + ':' + minutes + ':' + seconds,
			date: date + '.' + month + '.' + year
		};
	};
	return (
		<>
			<div className='AppContents'>
				<div className='Container'>
					<PageHeading heading={'Rapport'} />
					<section className='userInfo'>
						<div>Namn</div>
						<div>
							{user.firstName} {user.lastName}
						</div>
						<div>Telefon</div>
						<div>{user.phoneNo === 'null' ? 'Inegn data' : user.phoneNo}</div>
						<div>E-post</div>
						<div>{user.email === 'null' ? 'Inegn data' : user.email}</div>
					</section>
					<section className='TotalSum'>
						<div>{transactions.reduce((a, b) => a + (b.value.sum || 0), 0).toFixed(2)} €</div>
					</section>
					<section className='Report'>
						{transactions.map(transaction => {
							let DateAmdTime = GetDateAndTime(transaction.value.time);
							return (
								<>
									<div>{transaction.value.sum.toFixed(2) + '€'}</div>
									<div>
										{DateAmdTime.date} {DateAmdTime.time}
									</div>
								</>
							);
						})}
					</section>
				</div>
			</div>
		</>
	);
};
const Report = () => {
	let { path } = useRouteMatch();
	return (
		<Switch>
			<Route exact path={path}>
				<Navigation />
				<h3>Please select a user.</h3>
			</Route>
			<Route path={`${path}/:uid`}>
				<Navigation />
				<GetReport />
			</Route>
		</Switch>
	);
};

export default Report;
